module.exports = __webpack_public_path__ + "static/img/bg_theme_slash@2x.ea8c4f9.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/skin/bg_theme_slash@2x.png
// module id = AE3z
// module chunks = 1